



























































import { Component, Prop } from 'vue-property-decorator';
import { CircleIcon, DiscIcon, UploadIcon } from 'vue-feather-icons';
import dayjs from 'dayjs';
import {
  FivGoalGroupType,
  GetGoalGroupDto,
  IFivGoalGroup,
  IFivReport,
  IUploadCompetitionsReport,
  IUser,
  UserSpecialType,
} from 'admiral-core';
import CompetitionsReportCard from '@/views/pages/fivgoals/CompetitionsReportCard.vue';
import { CompetitionsApi } from '@/services/CompetitionsApi';
import { FivApi } from '@/services/FivApi';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';

@Component({ components: { UserSelect, CompetitionsReportCard, CircleIcon, DiscIcon, UploadIcon } })
export default class CompetitionsReportConfirmation extends mixins(BaseMixin) {
  @Prop({ type: Object })
  uploadedCompetitionsReport!: IUploadCompetitionsReport;

  @Prop({ type: Array, required: false })
  competitionsReportGoals!: IFivReport[];

  @Prop({ required: false, type: Object })
  goalGroup!: IFivGoalGroup;

  reportFiles = '';

  get formatReportDate() {
    return dayjs(this.uploadedCompetitionsReport?.competitionsReport?.reportDate).format(
      'DD.MM.YYYY',
    );
  }

  get formatDataDate() {
    return dayjs(this.uploadedCompetitionsReport?.competitionsReport?.dataDate).format(
      'DD.MM.YYYY',
    );
  }

  get incomplete() {
    return this.uploadedCompetitionsReport?.status === 'incomplete';
  }
  get error() {
    return this.uploadedCompetitionsReport?.status === 'error';
  }

  get errorMessage() {
    if (this.error) {
      if (this.uploadedCompetitionsReport.error.type === 'invalid-business-plan-report-excel') {
        return `Die Excel-Datei konnte nicht verarbeitet werden.
        Im Moment werden nur folgende Reports unterstützt: ${this.uploadedCompetitionsReport.error.allowedReports.join(
          ' ',
        )}`;
      }
    }
    return '';
  }
  cancel() {
    this.$emit('cancel');
  }

  isSavable() {
    return (
      this.uploadedCompetitionsReport?.status === 'completed' ||
      this.uploadedCompetitionsReport.competitionsReport?.goalGroup.agency ||
      this.uploadedCompetitionsReport.competitionsReport?.goalGroup.user
    );
  }
  async ok() {
    try {
      if (this.uploadedCompetitionsReport.competitionsReport) {
        const newReport = await CompetitionsApi.createCompetitionsReport({
          competitionsReport: this.uploadedCompetitionsReport.competitionsReport,
        });

        this.$emit('done', newReport.data);
      }
    } catch (e) {
      this.$toastr.e('Beim Speichern des Geschäftsplans ist etwas schief gelaufen.');
      throw e;
    }
  }
  get hasUserSelection() {
    return (
      !this.uploadedCompetitionsReport.competitionsReport?.goalGroup ||
      (this.uploadedCompetitionsReport.competitionsReport.goalGroup.user &&
        this.uploadedCompetitionsReport.competitionsReport.goalGroup.user.id !== this.user.id)
    );
  }
  async updateUser(user: IUser) {
    const goalGroupDto: GetGoalGroupDto = {
      groupType: FivGoalGroupType.CompetitionsKbv,
      year: this.fivGoalsFilter.year,
      user,
    };
    const response = await FivApi.getGoalGroup(goalGroupDto);
    if (this.uploadedCompetitionsReport.competitionsReport) {
      this.uploadedCompetitionsReport.competitionsReport.goalGroup = response.data;
    }
  }
  get kbvUsers() {
    return this.users.filter((user: IUser) => user.type === UserSpecialType.Kbv);
  }
}
